import {
  Stack,
  IconButton,
  Tooltip,
  Divider,
  Box,
  Paper,
  Button,
  Popper,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Avatar,
} from "@mui/material";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import React from "react";
import MoreVertRoundedIcon from "@mui/icons-material/MoreVertRounded";
import MoreVertIcon from "@mui/icons-material/MoreVert";

export const RowActions = ({ row, actions }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);

  const handleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setAnchorEl(anchorEl ? null : e.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <IconButton
        className="row-action-btn"
        size="small"
        onClick={handleClick}
        aria-label="Row actions"
      >
        <MoreVertIcon sx={{ fontSize: 18 }} />
      </IconButton>

      <Popper
        open={open}
        anchorEl={anchorEl}
        placement="bottom-start"
        style={{ zIndex: 1300 }}
      >
        <ClickAwayListener onClickAway={handleClose}>
          <Paper sx={{ p: 1 }}>
            <List dense>
              {actions?.map((action, i) => (
                <React.Fragment key={action.tooltip || i}>
                  <ListItemButton
                    sx={{
                      py: 0.5,
                      px: 1,
                      minHeight: 32,
                    }}
                    disabled={action.disabled?.(row)}
                    onClick={() => {
                      action.onClick(row);
                      handleClose();
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 28,
                        mr: 1,
                        ...(action.color && { color: `${action.color}.main` }),
                        "& .MuiSvgIcon-root": {
                          fontSize: 20,
                        },
                      }}
                    >
                      {action.icon}
                    </ListItemIcon>
                    <ListItemText
                      primary={action.tooltip}
                      sx={action.color && { color: `${action.color}.main` }}
                    />
                  </ListItemButton>
                  {i < actions.length - 1 && <Divider />}
                </React.Fragment>
              ))}
            </List>
          </Paper>
        </ClickAwayListener>
      </Popper>
    </>
  );
};
